import React, { useState } from 'react';
import { Box } from '@mui/material';
import { BrokenImage as BrokenImageIcon } from '@mui/icons-material';
import GiphyAttribution from './GiphyAttribution';

const MAX_WIDTH = 240;
const MAX_HEIGHT = 300;

/**
 * A GIF message, streamed from GIPHY's CDN and sized from its stored dimensions (no layout jump).
 * Uses the 200px-wide rendition (~0.5 MB vs several MB for the original) to keep chats light on mobile data.
 */
const ChatGif = ({ gif }) => {
  const [failed, setFailed] = useState(false);
  const ratio = gif.width > 0 && gif.height > 0 ? gif.width / gif.height : 1;
  const width = Math.round(Math.min(MAX_WIDTH, MAX_HEIGHT * ratio, gif.width || MAX_WIDTH));

  return (
    <Box data-testid="chat-gif">
      <Box
        sx={{
          width,
          maxWidth: '100%',
          aspectRatio: `${ratio}`,
          borderRadius: 1.5,
          overflow: 'hidden',
          bgcolor: 'grey.200',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {failed ? (
          <BrokenImageIcon color="disabled" />
        ) : (
          <Box
            component="img"
            src={gif.previewUrl || gif.url}
            alt={gif.title || 'GIF'}
            loading="lazy"
            onError={() => setFailed(true)}
            sx={{
              display: 'block', width: '100%', height: '100%', objectFit: 'cover',
            }}
          />
        )}
      </Box>
      <GiphyAttribution sx={{ px: 0.5, pt: 0.25 }} />
    </Box>
  );
};

export default ChatGif;
